export const REGRESSION_REPORT_KEYS = [
  'overall_counts',
  'flows_passed',
  'flows_with_failures',
  'failure_type_breakdown',
  'repeated_failures',
  'top_failing_flows',
  'failures_by_flow',
  'repeated_failures_grouped',
];

export const FLOW_REPORT_KEYS = [
  'failure_type_breakdown',
  'events_affected',
  'source_breakdown',
  'failing_attributes',
];

export const FAILURE_TYPE_ORDER = ['Attribute Mismatch', 'Order Issue'];

export const SOURCE_ORDER = ['mParticle only', 'GMA only', 'both mParticle and GMA'];

export const isObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

export const numberOrZero = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

export const countOrZero = (value) => {
  if (isObject(value)) return numberOrZero(value.count);
  return numberOrZero(value);
};

export const getOrderedEntries = (data, orderedKeys = []) => {
  if (!isObject(data)) return [];

  const knownEntries = orderedKeys.map((key) => [key, countOrZero(data[key])]);
  const knownKeys = new Set(orderedKeys);
  const extraEntries = Object.entries(data)
    .filter(([key]) => !knownKeys.has(key))
    .map(([key, value]) => [key, countOrZero(value)]);

  return [...knownEntries, ...extraEntries];
};

export const getSortedCountEntries = (data) =>
  isObject(data)
    ? Object.entries(data)
        .map(([label, count]) => [label, countOrZero(count)])
        .sort((a, b) => b[1] - a[1])
    : [];

export const findReportByKeys = (data, reportKeys) => {
  if (!isObject(data)) return null;

  const candidates = [
    data.ai_summary,
    data.summary,
    data.result,
    data.report,
    data.data?.ai_summary,
    data.data,
    data,
  ];

  return (
    candidates.find(
      (candidate) =>
        isObject(candidate) &&
        reportKeys.some((key) => Object.prototype.hasOwnProperty.call(candidate, key)),
    ) || null
  );
};

export const getAnalysisText = (data) => {
  if (!data) return '';
  if (typeof data === 'string') return data;

  const textCandidate = data.analysis || data.message || data.result || data.summary;

  return typeof textCandidate === 'string' ? textCandidate : JSON.stringify(data, null, 2);
};
